import { render, staticRenderFns } from "./DupesArea.vue?vue&type=template&id=6ddd69f0"
import script from "./DupesArea.vue?vue&type=script&lang=js"
export * from "./DupesArea.vue?vue&type=script&lang=js"
import style0 from "./DupesArea.vue?vue&type=style&index=0&id=6ddd69f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports